export default {
  order_center: '订单中心',
  orinary: '常规订单',
  insurance: '保险订单',
  order_search: '查询',
  order_status: '订单状态',
  remittance_identification_code: '付款识别码',
  exhibition_name: '展会名称',
  booth_Name: '展位号',
  order_number: '订单编号',
  sdopo: '下单开始日期',
  edoo: '下单结束日期',
  reset: '重置',
  search: '搜索',
  NCOTONTVTOD: '注：点击订单编号可查看订单详情信息.',
  exhibition_number: '展会编号',
  policy_no: '保单编号',
  sdoip: '下单起始日期',
  edoip: '下单结束日期',
  order_amount: '订单总计',
  RMB: '元',
  all: '全部',
  insured_company: '被保险公司',
  order_time: '下单时间',
  trustees: '经办人',
  contact_number: '联系电话',
  download: '下载',
  remove: '删除',
  order_details: '订单详情',
  deposit: '押金',
  booth_number: '展位',
  Exhibitor: '参展商',
  Person_in_charge: '现场负责人',
  order_remark: '备注',
  continue_payment: '继续支付',
  doio: '保险订单详情',
  Liability_insurance: '展览会责任保险',
  back: '返回',
  order_information: '订单信息',
  creation_time: '创建时间',
  Insured: '被保险公司信息',
  Name_of_Insured: '被保险公司名称',
  Unified_Social_Credit_Code: '统一社会信用代码',
  Contacts: '联系人',
  Postal_address: '通讯地址',
  Invoice_information: '开票信息',
  Application_number: '申请编号',
  Invoice_type: '发票类型',
  Invoice_status: '发票状态',
  Invoice_title: '发票抬头',
  Customer_remark: '备注',
  Taxpayer_identification_number: '纳税人识别号',
  e_mail: '邮箱',
  PolicyHolder: '投保人',
  PolicyHolderName: '投保公司名称',
  order_info_content: '确定删除该订单吗？点击确认将删除订单。订单删除后无法恢复',
  //table
  '暂无数据': '暂无数据',
  '展位号': '展位号',
  '保险名称': '保险名称',
  '单位': '单位',
  '规格': '规格',
  '承保方案': '承保方案',
  '面积': '面积',
  '数量': '数量',
  '单价': '单价',
  '商品类型': '商品类型',
  '商品名称': '商品名称',
  '押金': '押金',

  '小计': '小计',
  '状态': '状态',
  '保单': '保单',
  '出单失败原因': '出单失败原因',
  '未支付': '未支付',
  '已支付': '已支付',
  '已提交': '已提交',
  '待审核': '待审核',
  '审核通过': '审核通过',
  '已拒绝': '已拒绝',
  '已取消': '已取消',
  '已失效': '已失效',
  '部分支付': '部分支付',
  '基础版': '基础版',
  '升级版': '升级版',
  '豪华版': '豪华版',
  '待支付': '待支付',
  '已退款': '已退款',
  '已完成': '已完成',
  '已出保单': '已出保单',
  '出单失败': '出单失败',
  '已退保': '已退保',
  '已导出': '已导出',
  '可导出': '可导出',
  '已申请': '已申请',
  '确定取消订单吗': '确定取消订单吗?',
  '确定删除': '取消订单后，将不能恢复此订单',
  '云账单提示': '该笔订单已支付过押金，现在取消订单，需要进行押金退款申请后才可以退回已支付押金',
  '购买数量': '购买数量',
  '保单号': '保单号',
  '保单下载': '保单下载',

  '请输入订单编号': '请输入订单编号',
  '请输入展会名称': '请输入展会名称',
  '请输入展位号': '请输入展位号',

  '操作': '操作',
  '查看详情': '查看详情',
  //显示第1到第10条记录，总共122条记录
  '显示第': '显示第',
  '到第': '到第',
  '条记录，总共': '条记录，总共',
  '条记录': '条记录',

  '支付方式': '支付方式',
  '总计': '总计',
  '商品费用总计': '商品费用总计',
  '商品押金总计': '商品押金总计',
  '商品明细': '商品明细',
  '商品费用明细': '商品费用明细',
  '商品押金明细': '商品押金明细',
  '取消订单': '取消订单',
  '下载预租清单': '下载预租清单',
  '汇款信息': '汇款信息',
  '汇款截止时间': '汇款截止时间',
  '汇款账号信息': '汇款账号信息',
  '投保公司信息': '投保公司信息',

  '开户行名称': '开户行名称',
  '银行账号': '银行账号',
  '公司电话': '公司电话',
  '公司注册地址': '公司注册地址',
  '信息': '信息',
  '押金优惠': '押金优惠',
  '租金优惠': '租金优惠',
  '保单信息已更新，点击下载': '保单信息已更新，点击下载',
  '查询表单失败': '查询表单失败',

  '派送情况': '派送情况',
  '派送时间': '派送时间',
  '派送图片': '派送图片',
  '查看图片': '查看图片',

  '配送信息': '配送信息',



}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/order.js